module.exports = __webpack_public_path__ + "img/ai.db9fde08.png";